angular.module('unergie.main')
.controller('parsingCtrl', ($scope, $state, $location, DataAccess, DataAccessSearch, Sequentializer, TableGeneratorService, BoFeaturesService,
    ReferencesService, XmlParser, AlertManager, ApiAdmin, ErrorCatcher) => {
    $scope.parsGenAdmin = BoFeaturesService.isFeatureOn('parsGenAdmin')

    $scope.parsgens = {
        refreshing: false,
        show: {},
        columns: {
            selector: { label: 'Selection', mode: 'filter_only' },
            id: { label: 'ID', mode: 'search_operator', isVisible: false, mandatory: true },
            nature: { label: 'Nature', mode: 'search_wildcard' },
            type: { label: 'Type', mode: 'strict_wildcard', debounce: 30000 },
            filename: { label: 'Fichier', mode: 'search_wildcard' },
            functional_id: { label: 'ID fonctionnel', mode: 'strict_wildcard', length: 14, debounce: 30000 },
            sequence: { label: 'Sequence', mode: 'search_operator' },
            split_source: { label: 'Fichier origine', mode: 'search_wildcard' },
            status: { label: 'Statut', mode: 'strict_wildcard', debounce: 30000 },
            bucket: { label: 'Bucket', mode: 'search_wildcard' },
            nbok: { label: 'Nb Ok', mode: 'search_operator' },
            nbko: { label: 'Nb Ko', mode: 'search_operator' },
            duration: { label: 'Durée', mode: 'search_operator' },
            creation_ts: { label: 'Date', mode: 'search_date' },
            issue_id: { label: 'Jira', mode: 'search_wildcard' },
            additional_data: { label: 'Additional Data', mode: 'hidden' },
            id_request: { label: 'Id request', mode: 'hidden' },
            checksum: { label: 'Hash', mode: 'hidden' },
            error: { label: 'Erreur', mode: 'hidden' },
        },
    }

    if (!$scope.parsGenAdmin) {
        delete $scope.parsgens.columns.selector
    }


    ReferencesService.getRef('id-grd-contracts', true).then((mapping) => {
        $scope.grdContracts = _.map(mapping, (m) => ({ label: m.id, value: m.id }))
    })

    const transformData = function (data) {
        let lastDate = null
        let alternate = false
        return data.forEach((parsgen) => {
            if ((lastDate === null) || !moment(parsgen.creation_ts).startOf('day').isSame(lastDate)) {
                alternate = !alternate
                lastDate = moment(parsgen.creation_ts).startOf('day')
            }
            if (parsgen.issue_id) {
                parsgen.issue = {
                    id: parsgen.issue_id,
                    url: `https://unergie.atlassian.net/browse/${parsgen.issue_id}`,
                }
            }
            parsgen.alternate = alternate
        })
    }

    $scope.reparse = (parsgen, showResult) => {
        parsgen.reparsing = true
        let payload
        if (parsgen.additional_data) {
            payload = parsgen.additional_data
        } else {
            payload = _.pick(parsgen, ['bucket', 'type', 'filename'])
            payload.source = 's3'
        }
        if (parsgen.status !== 'TO_PARSE') {
            delete payload.id
        } else {
            payload.id = parsgen.id
        }
        // override
        const override = _.omit($scope.reParseTemplate, ['overrideGrd', 'overrideIdPCalendar'])
        if (_.keys(override).length) {
            payload.override = override
        } else {
            delete payload.override
        }
        payload.replay = true
        return XmlParser.parsing(payload).$promise.then((result) => {
            if (showResult) {
                AlertManager.addAlert({
                    type: 'success',
                    msg: 'Parsing ok',
                    detail: [JSON.stringify(result)],
                    hideDetails: true,
                })
                $scope.refresh()
            }
            return result
        })
        .catch(ErrorCatcher)
        .finally(() => {
            parsgen.reparsing = false
        })
    }

    $scope.getSelected = () => {
        return _.filter($scope.parsgens.instance.data, 'selected')
    }

    $scope.massReplay = () => {
        $scope.massReplaying = true
        const toReplay = $scope.getSelected()
        return Sequentializer.mapSeries(toReplay, $scope.reparse).then((result) => {
            AlertManager.addAlert({
                type: 'success',
                msg: 'Multi parsing ok',
                detail: result,
                hideDetails: true,
            })
            $scope.refresh()
        })
        .catch(ErrorCatcher)
        .finally(() => {
            $scope.massReplaying = false
        })
    }

    $scope.reParseFields = {}
    $scope.reParseTemplate = {}

    $scope.setReparseFields = (parsgen) => {
        $scope.reParseTemplate = parsgen.additional_data.override || {}
        switch (parsgen.type) {
            case 'C15':
                $scope.reParseTemplate.overrideGrd = !!$scope.reParseTemplate.id_grd_contract
                $scope.reParseTemplate.overrideIdPCalendar = !!$scope.reParseTemplate.id_p_calendar
                $scope.reParseFields = {
                    warning: {
                        type: 'label',
                        label: `<span class="red fa fa-warning"></span> <span class="red">Attention, une demande de correction doit avoir été faite `
                            + `+ traitée par Enedis avant de relancer le parsing via une surcharge !</span>`,
                    },
                    overrideGrd: {
                        label: 'Corriger une erreur de GRD ?',
                        type: 'checkbox',
                    },
                    id_grd_contract: {
                        hidden: (t) => {
                            if (!t.overrideGrd) {
                                delete t.id_grd_contract
                                return true
                            }
                            return false
                        },
                        label: 'GRD',
                        type: 'select',
                        enum: $scope.grdContracts,
                    },
                    overrideIdPCalendar: {
                        label: 'Corriger une erreur de calendier distributeur ?',
                        type: 'checkbox',
                    },
                    id_p_calendar: {
                        hidden: (t) => {
                            if (!t.overrideIdPCalendar) {
                                delete t.id_p_calendar
                                return true
                            }
                            return false
                        },
                        label: 'Choisissez le calendrier fournisseur cible',
                        type: 'select',
                        enum: [{ label: 'BASE', value: 'BASE' }, { label: 'HPHC', value: 'HPHC' }],
                    },
                    bypassCoefError: {
                        label: 'Ignorer les erreurs de coefficient de lecture <span class="red">(attention, vérifier que le coefficient est bien à 1 dans SGE)</span>',
                        type: 'checkbox',
                    },
                }
                break
            default:
                $scope.reParseFields = {}
        }
    }

    $scope.changeStatusPayload = {
        status: '',
    }

    $scope.changeStatusFields = {
        status: {
            label: 'Status',
            required: true,
            type: 'select',
            enum: [
                { label: 'FIXED', value: 'FIXED' },
                { label: 'IGNORED', value: 'IGNORED' },
                { label: 'TO_PARSE', value: 'TO_PARSE' },
            ],
        },
    }

    $scope.linkIssuePayload = {
        issue_id: '',
    }

    $scope.linkIssueFields = {
        issue_id: {
            label: 'Jira Id',
            required: false,
            type: 'text',
        },
    }

    $scope.createIssuePayload = {
        summary: '',
        description: '',
    }

    $scope.createIssueFields = {
        summary: {
            label: 'Titre',
            required: true,
            type: 'text',
        },
        description: {
            label: 'Description',
            required: true,
            type: 'textarea',
        },
    }

    $scope.toggleSelected = (parsgen) => {
        if (parsgen.nature === 'parsing') {
            parsgen.selected = true
        }
    }

    $scope.selectAll = () =>
        _.forEach($scope.parsgens.instance.data, (c) => {
            if (c.nature === 'parsing') {
                c.selected = true
            }
        })

    $scope.deSelectAll = () =>
        _.forEach($scope.parsgens.instance.data, (c) => {
            c.selected = false
            return true
        })

    $scope.linkIssue = (parsings, issue_id) => {
        $scope.massUpdating = true
        _.forEach(parsings, (p) => {
            p.updatingIssue = true
        })
        let updatePromise
        if (issue_id) {
            // attach to an existing jira issue
            updatePromise = ApiAdmin.linkIssueForParsings({ issueId: issue_id }, { parsings: _.map(parsings, 'id') }).$promise
        } else {
            // simply remove link
            updatePromise = DataAccess.updateParsGens({}, _.map(parsings, (p) => ({ id: p.id, issue_id: null }))).$promise
        }
        return updatePromise.then((result) => {
            AlertManager.addAlert({
                type: 'success',
                msg: `Lien avec jira ${issue_id} ok`,
                detail: _.map(result, JSON.stringify),
                hideDetails: true,
            })
            $scope.refresh()
        })
        .catch(ErrorCatcher)
        .finally(() => {
            $scope.massUpdating = false
            _.forEach(parsings, (p) => {
                p.updatingIssue = false
            })
        })
    }


    $scope.createIssue = (parsings, summary, description) => {
        $scope.massUpdating = true
        _.forEach(parsings, (p) => {
            p.updatingIssue = true
        })
        return ApiAdmin.createIssueForParsings({}, { summary, description, parsings: _.map(parsings, 'id') }).$promise.then((result) => {
            AlertManager.addAlert({
                type: 'success',
                msg: `Jira ${result.issue_id} créé`,
                detail: _.map(result, JSON.stringify),
                hideDetails: true,
            })
            $scope.refresh()
        })
        .catch(ErrorCatcher)
        .finally(() => {
            $scope.massUpdating = false
            _.forEach(parsings, (p) => {
                p.updatingIssue = false
            })
        })
    }

    $scope.updateStatus = (parsings, status) => {
        $scope.massUpdating = true
        const updates = _.map(parsings, (p) => {
            p.updatingStatus = true
            return { id: p.id, status }
        })
        return DataAccess.updateParsGens({}, updates).$promise.then((result) => {
            AlertManager.addAlert({
                type: 'success',
                msg: `Modification de statut en ${status} ok`,
                detail: _.map(result, JSON.stringify),
                hideDetails: true,
            })
            $scope.refresh()
        })
        .catch(ErrorCatcher)
        .finally(() => {
            $scope.massUpdating = false
            _.forEach(parsings, (p) => {
                p.updatingStatus = false
            })
        })
    }

    $scope.checkParsingsPayload = {
        limit: 50,
    }
    $scope.checkParsingsFields = {
        limit: {
            label: 'Nb par batch',
            required: true,
            type: 'number',
        },
    }

    $scope.checkParsingsToProcess = () => {
        $scope.checkingParsingsToProcess = true
        return ApiAdmin.checkParsingsToProcess({ limit: $scope.checkParsingsPayload.limit }).$promise.then((result) => {
            AlertManager.success(result.message)
            $scope.refresh()
        })
        .catch(ErrorCatcher)
        .finally(() => {
            $scope.checkingParsingsToProcess = false
        })
    }

    $scope.getSelectedNumber = () => _.countBy($scope.parsgens.instance.data, 'selected').true || 0

    const filter = Object.keys($location.search()).length ? $location.search() : { creation_ts: `>${moment().format('DD/MM/YYYY')}` }

    $scope.parsgens.instance = {
        page: () => 1,
        count: () => 25,
        sorting: () => ({}),
        filter: () => (filter),
    }

    $scope.refresh = () => TableGeneratorService.getTable($scope.parsgens, 'parsing-generations', undefined, transformData)

    $scope.refresh()
})
